import styled from "styled-components";

export const SubContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
`;

export const CompletedContainer = styled.div`
  width: 250px;
  display: flex;
  justify-content: space-around;
  border-radius: 8px;
  border: solid 1px #6898e3; ;
`;

export const SendReportButton = styled.div<{ isAlreadySent: boolean }>`
  width: 250px;
  height: 50px;
  margin: 5px;
  display: grid;
  place-items: center;
  font-size: 24px;
  cursor: pointer;
  border-radius: 8px;
  background-color: ${(props) =>
    props.isAlreadySent ? "#d9d9d9" : "#6898E3"}; /* Darker shades */
  color: ${(props) => (props.isAlreadySent ? "#000000" : "#ffffff")};
  justify-content: center;
  align-items: center;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

export const ChildInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 20px;
  border: solid 1px #c1c1c1ff;
  border-radius: 8px;
`;

export const ChildInfoTitle = styled.div`
  text-align: center;
  width: 100%;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
`;

export const BasicInfoContainer = styled.div`
  flex: 1 1 400px;
  margin: 5px;
  border: solid 1px #6898e3;
  border-radius: 8px;
`;

export const BasicInfoTitle = styled.div`
  width: 100%;
  text-align: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  color: #000000;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
`;

export const BasicInfoContent = styled.div``;

export const ChildName = styled.input`
  width: 150px;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
`;

export const ChildAge = styled.input`
  width: 75px;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
`;

export const MoreInfoContainer = styled.div`
  flex: 1 1 400px;
  margin: 5px;
  border: solid 1px #6898e3;
  border-radius: 8px;
`;

export const MoreInfoTitle = styled.div`
  width: 100%;
  text-align: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  color: #000000;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
`;

export const FullResult = styled.div`
  width: 100%;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const QuestionnaireAndResultPage = styled.div`
  width: 380px;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const TherapistContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 20px;
  border: solid 1px #6898e3;
  border-radius: 8px;
`;

export const TherapistTitle = styled.div`
  width: 100%;
  text-align: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
`;

export const VideoContainer = styled.div`
  border: solid 1px #6898e3;
  border-radius: 8px;
  flex: 1 1 200px;
  margin: 5px;
`;

export const VideoTitle = styled.div`
  text-align: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  color: #000000;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
  width: calc(100%+2px);
`;

export const AdminVideo = styled.div`
  width: 260px;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Video = styled.div`
  width: 100%;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Assign = styled.div`
  width: 50%;
  text-align: center;
  background-color: #6898e3;
  // background-color: #f9fff6;
  margin-left: 5px;
  border: solid 1px #6898e3;
  color: #ffffff;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const ReportContainer = styled.div`
  border: solid 1px #6898e3;
  border-radius: 8px;
  flex: 1 1 200px;
  margin: 5px;
`;

export const ReportTitle = styled.div`
  text-align: center;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: #dadada;
  color: #000000;
  font-size: 20px;
  height: 36px;
  line-height: 30px;
`;

export const AdminReport = styled.div`
  width: 260px;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  font-size: 20px;
  line-height: 45px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Report = styled.div`
  width: 100%;
  text-align: center;
  background-color: #6898e3;
  color: #ffffff;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Reject = styled.div`
  width: 50%;
  margin-right: 5px;
  text-align: center;
  // background-color: #f9fff6;
  background-color: #6898e3;
  border: solid 1px #6898e3;
  color: #ffffff;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Edit = styled.div`
  width: 50%;
  margin-right: 5px;
  text-align: center;
  background-color: #f9fff6;
  border: solid 1px #6898e3;
  color: #000000;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Submit = styled.div`
  width: 50%;
  margin-left: 5px;
  text-align: center;
  background-color: #f9fff6;
  border: solid 1px #6898e3;
  color: #000000;
  height: 36px;
  font-size: 20px;
  line-height: 30px;
  border-radius: 8px;
  cursor: pointer;
`;
